import React from 'react'
import PropTypes from 'prop-types'

const Menu = ({ color, width, height }) => {
  return (
    <svg width={width} height={height} fill='none' viewBox='0 0 18 12' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill={color}
        d='M1 12h16c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H1c-.55 0-1 .45-1 1s.45 1 1 1zM0 1c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1z'
      ></path>
    </svg>
  )
}

Menu.defaultProps = {
  color: '#424242',
  width: '14',
  height: '14',
}

Menu.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Menu
